export const routeConfigs = {
  auth: {
    path: 'auth',
    login: { path: '' },
  },
  admin: {
    path: 'admin',
    accounts: { path: 'accounts' },
  },
  visitor: {
    path: ':hubName',
    eventCalendar: {
      path: 'events',
      eventMap: { path: 'map' },
      oneRow: { path: 'one-row' },
      createEvent: { path: 'submit' },
      editorChoice: { path: 'events-editor-choice' },
      editorChoiceAlias: { path: 'editor-choice' },
      editorChoiceOneRow: { path: 'events-editor-choice/:mode' },
      favEvent: { path: 'custom-events/:customEventBtnId' },
      favEventOneRow: { path: 'custom-events/:customEventBtnId/:mode' },
      locationFilter: { path: 'location/:locationId' },
      groupLocationFilter: { path: 'location/group/:groupId' },
      locationFilterOneRow: { path: 'location/:locationId/one-row' },
      groupLocationFilterOneRow: { path: 'location/group/:groupId/one-row' },
      eventDetailsForEmbedding: { path: 'plain-details/:eventId' },
      submitFormForEmbedding: { path: 'submit-embedding' },
    },

    /** first eventDetailsModal is for lazying loading */
    eventDetailsModal: { path: 'details/:eventId' },
    // eventDetailsModal: { path: 'events/details/:eventId' },
    // eventMap: { path: 'events/map' },
    // createEvent: { path: 'events/create' },

    placeCalendar: {
      path: 'places',
      category: { path: 'category/:category' },
      placeMapAll: { path: 'map' },
      placeMap: { path: 'map/:category' },

      oneRow: { path: 'one-row' },

      // pathList: 'places/:category/:menuType',
      createPlace: { path: 'submit' },

      favCustomPlace: { path: 'fav/:favCustomPlaceBtnId' },
      favCustomPlaceOneRow: { path: 'fav/:favCustomPlaceBtnId/:mode' },
      customDefaultPlace: { path: 'custom/:categoryId' },
      customDefaultPlaceOneRow: { path: 'custom/:categoryId/one-row' },

      editorChoice: { path: 'editor-choice' },
      editorChoiceOneRow: { path: 'editor-choice/:mode' },

      placeDetailsModal: { path: 'details/:placeId' },
      locationFilter: { path: 'location/:locationId' },
      groupLocationFilter: { path: 'location/group/:groupId' },
      locationFilterOneRow: { path: 'location/:locationId/one-row' },
      groupLocationFilterOneRow: { path: 'location/group/:groupId/one-row' },
      placeDetailsForEmbedding: { path: 'plain-details/:placeId' },
      submitFormForEmbedding: { path: 'submit-embedding' },

      // link like /Savannah/ai/travel-buddy will not be able to open event/place details modal because of the module dependency
      // so move this to place module
      ai: {
        path: 'ai',
        travelBuddy: { path: 'travel-buddy' },
      },
    },

    ai: {
      path: 'ai',
      travelBuddy: { path: 'travel-buddy' },
    },

    /** for compatible with V2 routes */
    favCustomPlace: {
      path: 'custom-places/:favCustomPlaceBtnId',
    },
    defaultPlace: {
      path: 'places/:category',
    },
    customDefaultPlace: {
      path: 'places/:categoryId/custom',
    },
    placeMapFavCustomV2: {
      path: 'places-map/custom-places/:category',
    },

    jobBoard: {
      path: 'job-board',
    },
  },
  tripPlanner: {
    path: ':hubName',

    itineraryOriginal: { path: 'itineraries' },
    itinerary: { path: 'itineraries/:widgetCode', editMode: { path: 'edit' } },
    tripPlanner: { path: 'trip-planner' },
    /** for compatible with V2 routes */
    tour: { path: 'trips/tour-list' },
    singleTour: { path: 'trips/tour/:itineraryId' },
    trips: { path: 'trips' },

    dashboard: { path: 'dashboard' },
    dashboardTransparent: { path: 'dashboard-transparent' },
  },
  ai: {
    path: ':hubName/ai',
    travelBuddy: { path: 'travel-buddy' },
  },
  dashboard: {
    path: ':hubName/dashboard',
    // login: { path: 'login' },
    landingPage: { path: '' },
    eventCalendar: { path: 'events' },
    similarEvents: { path: 'similar-events' },
    similarPlaces: { path: 'similar-places' },
    exportEvents: { path: 'export-events' },
    exportPlaces: { path: 'export-places' },
    placeCalendar: { path: 'places' },
    placeManagement: { path: 'place-management/:tab' },
    eventManagement: { path: 'event-management' },
    branding: { path: 'branding' },
    ai: { path: 'ai' },
    travelBuddyKnowledgeBank: { path: 'tb-knowledge-bank' },
    travelBuddyDisplaySettings: { path: 'tb-display-settings' },

    itinerary: { path: 'itinerary/edit' },
    itineraryWidget: { path: 'itinerary/:widgetCode/edit' },
    itinerarySettings: { path: 'itinerary-settings' },
    tripPlanner: { path: 'trip-planner' },
    tripPlannerOtherSettings: { path: 'trip-planner-settings' },

    jobBoard: { path: 'job-board' },
    jobBoardSettings: { path: 'job-board-settings' },
    jobManagement: { path: 'job-management/:tab' },
  },
  // jobBoard: {
  //   path: ':hubName/job-board',
  // },
};

export function getRouteUrl(route: any, parameters?: any): string {
  let routeParameters = [];
  let config = (route.config || []).slice();

  if (parameters) {
    config.forEach((path, index) => {
      if (path.startsWith(':')) {
        routeParameters.push({ path, index });
      }
    });

    for (let parameter of routeParameters) {
      config[parameter.index] = parameters[parameter.path.substr(1, parameter.length)];
    }
  }

  let parentUrl = route.parent ? getRouteUrl(route.parent, parameters) : '';
  let childUrl = config.join('/');

  if (childUrl) {
    parentUrl += '/';
  }

  return `${parentUrl}${childUrl}`;
}

function setRouteConfigRelationship(child: any, parent: any) {
  for (let propName in child) {
    if (propName !== 'path' && child.hasOwnProperty(propName)) {
      setRouteConfigRelationship(child[propName], child);
    }
  }

  child.parent = parent;
  child.config = child.path.split('/');
}

for (let propName in routeConfigs) {
  if (routeConfigs.hasOwnProperty(propName)) {
    setRouteConfigRelationship(routeConfigs[propName], routeConfigs);
  }
}
